import styled from 'styled-components';
import { StyledLoadingPlaceholder } from '@tryhackme/thm-ui-components';

import { CommonHeaderContentStyles, DarkModeTableAdjustmentStyles } from 'src/common/legacy-styles';
import { TextAndBackgroundColorStyles } from 'src/common/legacy-styles/text-and-bg-color';

export const StyledRoomContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-self: center;
  width: 100%;
  ${CommonHeaderContentStyles};
  ${DarkModeTableAdjustmentStyles};
  ${TextAndBackgroundColorStyles};
`;

export const StyledLoading = styled.div`
  ${StyledLoadingPlaceholder}
  width: 100%;
  height: 4.8rem;
`;

export const StyledLoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-top: 1.6rem;
`;
